/* Recolours the owner's 3D carrier (the Spline scene) in the browser, so one scene file serves every colour.
   The colours come from Theme settings > WaterLand > 3D model colours (calibrated so the lit model matches each
   colour's packshot). Each part keeps its shade relative to the main fabric (lighter straps, darker trim); near-black
   parts (buckles, webbing) stay black.
   It reads Spline's internal scene graph (each material's colour layers). When that isn't there, wlTint returns false
   and the caller keeps the packshot, so a shopper never sees the model in the wrong colour.
   wlTint(app, '#rrggbb', ms): app is the viewer's _spline; ms > 0 morphs from the current colours.
   wlTint.mix(app, '#aaaaaa', '#bbbbbb', k): sets the model k of the way from one colour to the next, at once (Home's
   scroll scene drives it every frame; the per-colour targets are worked out once and cached). Returns false when the
   scene can't be recoloured. */
(function () {
  if (window.wlTint) return;
  var REF_L = (1 + 40 / 255) / 2; /* lightness of the scene's main fabric as exported (#28b4ff) */

  function colourUniforms(app) {
    var out = [];
    app._scene.traverse(function (o) {
      if (!o.isMesh || !o.material) return;
      [].concat(o.material).forEach(function (m) {
        ((m && m.layers) || []).forEach(function (l) {
          if (!l || l.type !== 'color' || !l.uniforms) return;
          var u = l.uniforms['f' + l.id + '_color'];
          if (u && u.value && u.value.isColor && out.indexOf(u) < 0) out.push(u);
        });
      });
    });
    return out;
  }

  window.wlTint = function (app, hex, ms) {
    try {
      if (!app || !app._scene || !/^#[0-9a-f]{6}$/i.test(hex || '')) return false;
      var list = colourUniforms(app);
      if (!list.length) return false;
      var C = list[0].value.constructor, th = {}, oh = {};
      new C(hex).getHSL(th);
      var jobs = [];
      list.forEach(function (u) {
        if (!u.wlOrig) u.wlOrig = u.value.clone();
        u.wlOrig.getHSL(oh);
        if (oh.l < 0.06) return;
        jobs.push({ u: u, from: u.value.clone(), to: new C().setHSL(th.h, th.s, Math.min(0.95, th.l * oh.l / REF_L)) });
      });
      var id = (app.wlTintId || 0) + 1, t0 = performance.now();
      app.wlTintId = id;
      var step = function (now) {
        if (app.wlTintId !== id || app.disposed) return;
        var k = ms > 0 ? Math.min(1, (now - t0) / ms) : 1;
        k = k * k * (3 - 2 * k);
        jobs.forEach(function (j) { j.u.value.copy(j.from).lerp(j.to, k); });
        /* a still model is drawn by accumulating frames; restart that so the new colour shows */
        app.currentTAAFrame = 0;
        if (typeof app.requestRender === 'function') app.requestRender();
        if (k < 1) requestAnimationFrame(step);
      };
      step(t0);
      return true;
    } catch (e) {
      return false;
    }
  };

  /* the per-part target colours for one hex, cached on the app */
  function targets(app, hex) {
    var c = app.wlMix || (app.wlMix = { list: null, t: {} });
    if (!c.list) {
      c.list = colourUniforms(app).filter(function (u) {
        if (!u.wlOrig) u.wlOrig = u.value.clone();
        var oh = {}; u.wlOrig.getHSL(oh); u.wlL = oh.l;
        return oh.l >= 0.06;
      });
    }
    if (!c.list.length) return null;
    var key = hex.toLowerCase();
    if (!c.t[key]) {
      var C = c.list[0].value.constructor, th = {};
      new C(hex).getHSL(th);
      c.t[key] = c.list.map(function (u) { return new C().setHSL(th.h, th.s, Math.min(0.95, th.l * u.wlL / REF_L)); });
    }
    return c.t[key];
  }
  window.wlTint.mix = function (app, a, b, k) {
    try {
      if (!app || !app._scene || !/^#[0-9a-f]{6}$/i.test(a || '') || !/^#[0-9a-f]{6}$/i.test(b || '')) return false;
      var ta = targets(app, a), tb = targets(app, b);
      if (!ta || !tb) return false;
      k = Math.min(1, Math.max(0, +k || 0));
      app.wlTintId = (app.wlTintId || 0) + 1; /* stops any running wlTint morph */
      app.wlMix.list.forEach(function (u, i) { u.value.copy(ta[i]).lerp(tb[i], k); });
      app.currentTAAFrame = 0;
      return true;
    } catch (e) {
      return false;
    }
  };
})();
